export const SETPRJLISTFORTKT = "SETPRJLISTFORTKT";
export const SETSUBPRJLIST = "SETSUBPRJLIST";
export const SETISSUETYPELIST = "SETISSUETYPELIST";
export const SETTICKETDETAIL = "SETTICKETDETAIL";
export const SETTICKETLIST = "SETTICKETLIST";
export const SETTKTCOLUMNLIST = "SETTKTCOLUMNLIST";
export const SETUSERTKTCOLUMNLIST = "SETUSERTKTCOLUMNLIST";
export const SETUSERDEFAULTLIST = "SETUSERDEFAULTLIST";
export const CLEARDOC = "CLEARDOC";
export const SETTICKETCOUNTLIST = "SETTICKETCOUNTLIST";
export const SETAGENTLIST = "SETAGENTLIST";
export const SETREPLYMAILLIST = "SETREPLYMAILLIST";
export const SETCLOSEDEMAILCONTENT = "SETCLOSEDEMAILCONTENT";
export const SETUSERREVIEWEMAILCONTENT = "SETUSERREVIEWEMAILCONTENT";
export const SETTICKETSBASICFILTERDATA = "SETTICKETSBASICFILTERDATA";
